import React, { Fragment, useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, postData } from '../../../apiService';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Link } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import CopyrightIcon from '@mui/icons-material/Copyright';
import Select from 'react-select';
// import BillPrint from '../sale/Bill';
import generateSalePDF from '../sale/Bill';
import ReactDOM from 'react-dom';
import '../shared.css';

const SaleCreate = () => {
    const { id } = useParams();
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [confirmRemove, setConfirmRemove] = useState(null);
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate } = useAuth();

    const [selectedGWPorPWP, setSelectedGWPorPWP] = useState(false);
    const [selectedSalesMan, setSelectedSalesMan] = useState("");
    const [dropdownSalesManOptions, setDropdownSalesManOptions] = useState([]);
    const [selectedDiscType, setSelectedDiscType] = useState("");
    const [dropdownDiscTypeOptions, setDropdownDiscTypeOptions] = useState([]);
    const [selectedCardType, setSelectedCardType] = useState("");
    const [dropdownCardTypeOptions, setDropdownCardTypeOptions] = useState([]);

    const [formData, setFormData] = useState({});
    const [invoicedeatils, setInvoicedeatils] = useState([]);
    const [itemdetails, setItemDetails] = useState([]);
    const [itemsOptions, setItemsrOptions] = useState([]);
    const [selectedItems, setSelectedItem] = useState(null);
    const [isValid, setIsValid] = useState(true);

    const [modalData, setModalData] = useState({
        SlNo: '0', ItemName: '', ItemId: '', Quantity: '1',
        Rate: '', Amount: '', DiscountPercentage: '', DiscountAmount: '',
        HSNCode: '', GSTRate: '', TaxableAmount: '',
        CGSTAmount: '', SGSTAmount: '', IGSTAmount: '', TotalAmount: '', balanceStock: 0,
    });

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) { logout(); return; }
    }, [isAuthenticated, companyId, branchId, token, logout]);

    useEffect(() => {
        fetchDropdownSalesManOptions();
        fetchDropdownCardTypeOptions();
        fetchDropdownDiscTypeOptions();
        fetchmaxbillno();
        fetchItems();
    }, []);

    const fetchmaxbillno = () => {
        fetchData('SaleApi', `/MaxBillno/${companyId}/${branchId}`, token)
            .then(r => r.response_data)
            .then(data => setFormData(prev => ({
                ...prev,
                BillNumber: data.BillNumber,
                BillPrefix: data.BillPrefix,
                AdditionalDiscountPercentage: 0,
            })))
            .catch(err => console.error('Error fetching Max Billno', err));
    };

    const fetchDropdownSalesManOptions = () => {
        fetchData('SaleApi', `/SalesMan/${companyId}/${branchId}`, token)
            .then(r => r.response_data).then(data => setDropdownSalesManOptions(data))
            .catch(err => console.error('Error fetching SalesMan:', err));
    };
    const fetchDropdownDiscTypeOptions = () => {
        fetchData('SaleApi', `/DiscType/${companyId}/${branchId}`, token)
            .then(r => r.response_data).then(data => setDropdownDiscTypeOptions(data))
            .catch(err => console.error('Error fetching DiscType:', err));
    };
    const fetchDropdownCardTypeOptions = () => {
        fetchData('SaleApi', `/CardType/${companyId}/${branchId}`, token)
            .then(r => r.response_data).then(data => setDropdownCardTypeOptions(data))
            .catch(err => console.error('Error fetching CardType:', err));
    };

    const fetchItems = async () => {
        try {
            const response = await fetchData('SaleApi', `/Item/${companyId}/${branchId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(item => ({
                    value: item.Id,
                    label: item.Code + '-' + item.Name,
                }));
                setItemsrOptions(options);
                setItemDetails(response.response_data);
            }
            const d = new Date();
            const formattedDate = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
            setFormData(prev => ({
                ...prev,
                BillDate: formattedDate,
                BranchId: branchId,
                CompanyId: companyId,
                CreatedBy: userId,
            }));
        } catch (err) { console.error('Error fetching items:', err); }
    };

    // ── Calculation helpers ──────────────────────────────────────────────────────
    const calcItemAmounts = (item, additionalDisc, gstNumber) => {
        const rate = parseFloat(item.Rate) || 0;
        const gstrate = parseFloat(item.GSTRate) || 0;
        const discountPercentage = parseFloat(item.DiscountPercentage) || 0;
        const quantity = parseFloat(item.Quantity) || 0;

        const amount = (quantity * rate).toFixed(2);
        const discamt = ((rate * discountPercentage) / 100).toFixed(2);
        const Addidiscamt = ((rate * additionalDisc) / 100).toFixed(2);
        const totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
        const grate = (rate - totdiscount).toFixed(2);
        const salerate = (grate / (1 + gstrate / 100)).toFixed(2);
        const taxableamount = (quantity * salerate).toFixed(2);

        let cgst = 0, sgst = 0, igst = 0;
        if (!gstNumber) {
            cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
            sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
        } else {
            const prefix = gstNumber.toString().substring(0, 2);
            if (prefix !== branchstate) {
                igst = ((taxableamount * gstrate) / 100).toFixed(2);
            } else {
                cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
            }
        }
        const totalAmount = Math.round(
            (parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2)
        );
        return {
            ...item,
            Amount: amount,
            DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
            AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
            AdditionalDiscountPercentage: parseFloat(additionalDisc).toFixed(2),
            TaxableAmount: parseFloat(taxableamount).toFixed(2),
            CGSTAmount: parseFloat(cgst).toFixed(2),
            SGSTAmount: parseFloat(sgst).toFixed(2),
            IGSTAmount: parseFloat(igst).toFixed(2),
            TotalAmount: parseFloat(totalAmount).toFixed(2),
        };
    };

    const totalCalculation = (Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvamt, CardAmount, UPIAmount) => {
        const gvAmount = parseFloat(gvamt) || 0;
        const netAmt = parseFloat(TaxableAmount) + parseFloat(CGSTAmount) + parseFloat(SGSTAmount) + parseFloat(IGSTAmount);
        const roundOffValue = Math.round(netAmt) - netAmt;
        let totalAmt = parseFloat((netAmt + roundOffValue)).toFixed(2);
        totalAmt = parseFloat(totalAmt - gvAmount).toFixed(2);
        const cashamt = parseFloat(totalAmt - CardAmount - UPIAmount).toFixed(2);
        setFormData(prev => ({
            ...prev,
            TotalQuantity: Quantity,
            TotalAmount: Amount.toFixed(2),
            DiscountAmount: DiscountAmount.toFixed(2),
            TaxableAmount: TaxableAmount.toFixed(2),
            CGSTAmount: CGSTAmount.toFixed(2),
            SGSTAmount: SGSTAmount.toFixed(2),
            IGSTAmount: IGSTAmount.toFixed(2),
            RoundOff: roundOffValue.toFixed(2),
            GrandTotal: parseFloat(totalAmt).toFixed(2),
            CashAmount: parseFloat(cashamt).toFixed(2),
            GVAmount: gvAmount.toFixed(2),
            CardAmount: CardAmount.toFixed(2),
            UPIAmount: UPIAmount.toFixed(2),
            CashDiscount: 0,
            ModifiedBy: userId,
        }));
    };

    const recalcAll = (items, additionalDisc, gstNumber, gvamt, cardAmt, upiAmt) => {
        const updated = items.map(item => calcItemAmounts(item, additionalDisc, gstNumber));
        setInvoicedeatils(updated);
        const Qty  = updated.reduce((s, i) => s + parseFloat(i.Quantity), 0);
        const Amt  = updated.reduce((s, i) => s + parseFloat(i.Amount), 0);
        const Disc = updated.reduce((s, i) => s + parseFloat(i.DiscountAmount || 0), 0);
        const AddiDisc = updated.reduce((s, i) => s + parseFloat(i.AdditionalDiscountAmount || 0), 0);
        const Tax  = updated.reduce((s, i) => s + parseFloat(i.TaxableAmount), 0);
        const CGST = updated.reduce((s, i) => s + parseFloat(i.CGSTAmount), 0);
        const SGST = updated.reduce((s, i) => s + parseFloat(i.SGSTAmount), 0);
        const IGST = updated.reduce((s, i) => s + parseFloat(i.IGSTAmount), 0);
        const Tot  = updated.reduce((s, i) => s + parseFloat(i.TotalAmount), 0);
        totalCalculation(Qty, Amt, Disc + AddiDisc, Tax, CGST, SGST, IGST, Tot, gvamt, cardAmt, upiAmt);
    };

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;
        const additionalDisc = name === 'AdditionalDiscountPercentage' ? parseFloat(value) || 0 : parseFloat(formData.AdditionalDiscountPercentage) || 0;
        const gstNumber = name === 'GSTNumber' ? value : formData.GSTNumber;
        const gvamt   = name === 'GVAmount'   ? parseFloat(value) || 0 : parseFloat(formData.GVAmount)   || 0;
        const cardAmt = name === 'CardAmount' ? parseFloat(value) || 0 : parseFloat(formData.CardAmount) || 0;
        const upiAmt  = name === 'UPIAmount'  ? parseFloat(value) || 0 : parseFloat(formData.UPIAmount)  || 0;

        if (['AdditionalDiscountPercentage', 'GSTNumber', 'GVAmount', 'CardAmount', 'UPIAmount'].includes(name)) {
            setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value, ModifiedBy: userId }));
            recalcAll(invoicedeatils, additionalDisc, gstNumber, gvamt, cardAmt, upiAmt);
        } else {
            setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
        }
    };

    const handleItemSelect = (selectedOption) => {
        setSelectedItem(selectedOption);
        if (!selectedOption) return;
        const detail = itemdetails.find(i => i.Id === selectedOption.value);
        const additionalDisc = parseFloat(formData.AdditionalDiscountPercentage) || 0;
        if (detail) {
            const qty     = parseFloat(modalData.Quantity) || 0;
            const rate    = parseFloat(detail.MRP.toFixed(2)) || 0;
            const gstrate = parseFloat(detail.GSTRate.toFixed(2)) || 0;
            const discPct = parseFloat(detail.DiscountPercentage.toFixed(2)) || 0;
            const discamt     = ((rate * discPct) / 100).toFixed(2);
            const Addidiscamt = ((rate * additionalDisc) / 100).toFixed(2);
            const grate   = (rate - parseFloat(discamt) - parseFloat(Addidiscamt)).toFixed(2);
            const salerate = (grate / (1 + gstrate / 100)).toFixed(2);
            const taxable = (qty * salerate).toFixed(2);
            let cgst = 0, sgst = 0, igst = 0;
            if (!formData.GSTNumber) {
                cgst = ((taxable * (gstrate / 2)) / 100).toFixed(2); sgst = cgst;
            } else {
                const p = formData.GSTNumber.toString().substring(0, 2);
                if (p !== branchstate) igst = ((taxable * gstrate) / 100).toFixed(2);
                else { cgst = ((taxable * (gstrate / 2)) / 100).toFixed(2); sgst = cgst; }
            }
            const total = Math.round((parseFloat(taxable) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));
            setModalData(prev => ({
                ...prev,
                Rate: rate.toFixed(2), GSTRate: gstrate.toFixed(2), HSNCode: detail.HSNCode,
                DiscountPercentage: discPct.toFixed(2),
                ItemName: selectedOption.label, ItemId: selectedOption.value,
                Amount: (qty * rate).toFixed(2),
                DiscountAmount: parseFloat(discamt * qty).toFixed(2),
                AdditionalDiscountAmount: parseFloat(Addidiscamt * qty).toFixed(2),
                AdditionalDiscountPercentage: additionalDisc.toFixed(2),
                TaxableAmount: parseFloat(taxable).toFixed(2),
                CGSTAmount: parseFloat(cgst).toFixed(2), SGSTAmount: parseFloat(sgst).toFixed(2),
                IGSTAmount: parseFloat(igst).toFixed(2), TotalAmount: parseFloat(total).toFixed(2),
                balanceStock: detail.balanceStock,
            }));
        }
    };

    const handleModalInputChange = (e) => {
        const { name, value } = e.target;
        const qty = name === 'Quantity' ? parseFloat(value) || 0 : parseFloat(modalData.Quantity) || 0;
        if (name === 'Quantity') setIsValid(qty <= modalData.balanceStock);

        const additionalDisc = parseFloat(formData.AdditionalDiscountPercentage) || 0;
        const rate    = parseFloat(modalData.Rate) || 0;
        const gstrate = parseFloat(modalData.GSTRate) || 0;
        const discPct = parseFloat(modalData.DiscountPercentage) || 0;
        const discamt     = ((rate * discPct) / 100).toFixed(2);
        const Addidiscamt = ((rate * additionalDisc) / 100).toFixed(2);
        const grate   = (rate - parseFloat(discamt) - parseFloat(Addidiscamt)).toFixed(2);
        const salerate = (grate / (1 + gstrate / 100)).toFixed(2);
        const taxable = (qty * salerate).toFixed(2);
        let cgst = 0, sgst = 0, igst = 0;
        if (!formData.GSTNumber) {
            cgst = ((taxable * (gstrate / 2)) / 100).toFixed(2); sgst = cgst;
        } else {
            const p = formData.GSTNumber.toString().substring(0, 2);
            if (p !== branchstate) igst = ((taxable * gstrate) / 100).toFixed(2);
            else { cgst = ((taxable * (gstrate / 2)) / 100).toFixed(2); sgst = cgst; }
        }
        const total = Math.round((parseFloat(taxable) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));
        setModalData(prev => ({
            ...prev,
            [name]: value,
            Quantity: qty,
            Amount: (qty * rate).toFixed(2),
            DiscountAmount: parseFloat(discamt * qty).toFixed(2),
            AdditionalDiscountAmount: parseFloat(Addidiscamt * qty).toFixed(2),
            AdditionalDiscountPercentage: additionalDisc.toFixed(2),
            TaxableAmount: parseFloat(taxable).toFixed(2),
            CGSTAmount: parseFloat(cgst).toFixed(2), SGSTAmount: parseFloat(sgst).toFixed(2),
            IGSTAmount: parseFloat(igst).toFixed(2), TotalAmount: parseFloat(total).toFixed(2),
        }));
    };

    const saveModalData = () => {
        if (!modalData.ItemId) { setErrorMessageModel("Item is required"); return; }
        if (!modalData.Quantity || isNaN(modalData.Quantity)) { setErrorMessageModel("Quantity must be a valid number"); return; }
        if (parseFloat(modalData.Quantity) > modalData.balanceStock) { setErrorMessageModel("Quantity exceeds available stock."); return; }
        setErrorMessageModel('');
        const updated = [modalData, ...invoicedeatils];
        setInvoicedeatils(updated);
        setModalData({
            SlNo: '0', ItemName: '', ItemId: '', Quantity: '1',
            Rate: '', Amount: '', DiscountPercentage: '', DiscountAmount: '',
            HSNCode: '', GSTRate: '', TaxableAmount: '',
            CGSTAmount: '', SGSTAmount: '', IGSTAmount: '', TotalAmount: '', balanceStock: 0,
        });
        setSelectedItem(null);
        const Qty  = updated.reduce((s, i) => s + parseFloat(i.Quantity), 0);
        const Amt  = updated.reduce((s, i) => s + parseFloat(i.Amount), 0);
        const Disc = updated.reduce((s, i) => s + parseFloat(i.DiscountAmount || 0), 0);
        const AddiDisc  = updated.reduce((s, i) => s + parseFloat(i.AdditionalDiscountAmount || 0), 0);
        const Tax  = updated.reduce((s, i) => s + parseFloat(i.TaxableAmount), 0);
        const CGST = updated.reduce((s, i) => s + parseFloat(i.CGSTAmount), 0);
        const SGST = updated.reduce((s, i) => s + parseFloat(i.SGSTAmount), 0);
        const IGST = updated.reduce((s, i) => s + parseFloat(i.IGSTAmount), 0);
        const Tot  = updated.reduce((s, i) => s + parseFloat(i.TotalAmount), 0);
        totalCalculation(Qty, Amt, Disc + AddiDisc, Tax, CGST, SGST, IGST, Tot,
            parseFloat(formData.GVAmount) || 0, parseFloat(formData.CardAmount) || 0, parseFloat(formData.UPIAmount) || 0);
    };

    const removeRecord = (index) => setConfirmRemove(index);

    const confirmRemoveRecord = () => {
        const index = confirmRemove;
        setConfirmRemove(null);
        const updated = [...invoicedeatils];
        updated.splice(index, 1);
        setInvoicedeatils(updated);
        const Qty  = updated.reduce((s, i) => s + parseFloat(i.Quantity), 0);
        const Amt  = updated.reduce((s, i) => s + parseFloat(i.Amount), 0);
        const Disc = updated.reduce((s, i) => s + parseFloat(i.DiscountAmount || 0), 0);
        const AddiDisc  = updated.reduce((s, i) => s + parseFloat(i.AdditionalDiscountAmount || 0), 0);
        const Tax  = updated.reduce((s, i) => s + parseFloat(i.TaxableAmount), 0);
        const CGST = updated.reduce((s, i) => s + parseFloat(i.CGSTAmount), 0);
        const SGST = updated.reduce((s, i) => s + parseFloat(i.SGSTAmount), 0);
        const IGST = updated.reduce((s, i) => s + parseFloat(i.IGSTAmount), 0);
        const Tot  = updated.reduce((s, i) => s + parseFloat(i.TotalAmount), 0);
        totalCalculation(Qty, Amt, Disc + AddiDisc, Tax, CGST, SGST, IGST, Tot,
            parseFloat(formData.GVAmount) || 0, parseFloat(formData.CardAmount) || 0, parseFloat(formData.UPIAmount) || 0);
    };

    // const handlePrint = async (SaleId) => {
    //     try {
    //         const response = await fetchData('SaleApi', `/SalePrint/${SaleId}/${branchId}`, token);
    //         const labelData = response.response_data;
    //         const iframe = document.createElement('iframe');
    //         iframe.style.display = 'none';
    //         document.body.appendChild(iframe);
    //         const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
    //         iframeDocument.write('<html><head><style>@media print { header, footer { display: none !important; } }</style></head><body>');
    //         ReactDOM.render(<BillPrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />, iframeDocument.body);
    //         iframeDocument.write('</body></html>');
    //         iframeDocument.close();
    //         setTimeout(() => { iframe.contentWindow.print(); }, 1000);
    //     } catch (error) { console.error('Error printing Invoice:', error); }
    // };

    const handlePrint = async (SaleId) => {
        try {
            const response = await fetchData('SaleApi', `/SalePrint/${SaleId}/${branchId}`, token);
            console.log('SalePrint API response:', response);
            generateSalePDF(response.response_data);
        } catch (error) {
            console.error('Error printing Invoice:', error);
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);
        if (!formData.CustomerName)  { setErrorMessage('Customer Name is required!');  setIsLoading(false); return; }
        if (!formData.ContactNumber) { setErrorMessage('Contact Number is required!'); setIsLoading(false); return; }
        if (formData.CashAmount < 0) { setErrorMessage('Cash Amount less than 0 is not allowed!'); setIsLoading(false); return; }
        if (formData.CardAmount > 0 && !formData.CardNumber) { setErrorMessage('Card Number is required when Card Amount > 0!'); setIsLoading(false); return; }
        if (formData.CardAmount > 0 && !selectedCardType)    { setErrorMessage('Card Type is required when Card Amount > 0!');   setIsLoading(false); return; }
        if (!selectedSalesMan) { setErrorMessage('Sales Man is required!'); setIsLoading(false); return; }
        if (!selectedDiscType && formData.AdditionalDiscountPercentage > 0) { setErrorMessage('Disc Type is required!'); setIsLoading(false); return; }
        if (selectedDiscType == "1" && !formData.SCMembershipNumber) { setErrorMessage('SC Membership Number is required!'); setIsLoading(false); return; }
        if (selectedDiscType == "2" && !formData.VoucherNumber)      { setErrorMessage('Voucher Number is required!');       setIsLoading(false); return; }
        if (formData.UPIAmount > 0 && !formData.UPINumber) { setErrorMessage('UPI Number is required when UPI Amount > 0!'); setIsLoading(false); return; }
        if (!invoicedeatils || invoicedeatils.length === 0) { setErrorMessage('Item Details are required!'); setIsLoading(false); return; }

        const CreateData = {
            Sale: {
                ...formData,
                ModifiedBy: userId, BranchId: branchId, CompanyId: companyId,
                SalesManId: selectedSalesMan, GWPorPWPIncluded: selectedGWPorPWP,
                CardType: parseFloat(formData.CardAmount) > 0 ? selectedCardType : null,
            },
            SaleDetails: invoicedeatils,
        };
        postData('SaleApi', CreateData, token)
            .then(response => {
                history.push('/Home');
                if (response.response === 'Sale Create Successfully') handlePrint(response.kotId);
            })
            .catch(err => { console.error('Error creating record:', err); setIsLoading(false); });
    };

    const formatDateForInput = (dateString) => {
        if (!dateString) return '';
        const d = new Date(dateString);
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    };

    // ── Inline styles for the totals panel ──────────────────────────────────────
    const tpanelStyle = {
        display: 'flex', gap: 0, background: '#fff',
        border: '1px solid rgba(200,212,224,0.55)',
        borderRadius: 8, boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
        marginBottom: 8, overflow: 'hidden', position: 'relative',
    };
    const tleftStyle = {
        display: 'flex', flexDirection: 'column', padding: '10px 14px 10px',
        flex: '0 0 220px', borderRight: '1px solid rgba(200,212,224,0.55)',
        background: '#fafbfd',
    };
    const trightStyle = {
        flex: 1, display: 'flex', flexDirection: 'column', gap: 0,
        padding: '10px 14px 10px', minWidth: 0,
    };
    const tsumRowStyle = {
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '3px 6px', borderRadius: 4,
    };
    const tsumLabelStyle = {
        fontSize: 11, fontWeight: 600, color: '#64748b',
        letterSpacing: '0.3px', textTransform: 'uppercase',
    };
    const tsumInputStyle = {
        width: 90, height: 24, padding: '0 6px',
        border: '1.5px solid rgba(200,212,224,0.8)', borderRadius: 4,
        fontSize: 12.5, fontWeight: 700, color: '#1e293b',
        textAlign: 'right', background: '#fff', boxSizing: 'border-box',
        fontFamily: 'inherit',
    };
    const tsumReadonlyStyle = { ...tsumInputStyle, background: '#f5f7fa', color: '#475569' };

    return (
        <Fragment>
            <div className="pg-container">

                {/* ── Header ── */}
                <div className="pg-header">
                    <h5 className="pg-title">Sale — Create</h5>
                    <div className="pg-header-actions">
                        <div className="pg-action-row">
                            <button className="pg-btn pg-btn-success" onClick={handleSubmit} disabled={isLoading}>
                                <DoneIcon /> {isLoading ? <CircularProgress size={14} color="inherit" /> : 'Save'}
                            </button>
                            <Link to="/Home" className="pg-btn pg-btn-danger">
                                <CloseIcon /> Cancel
                            </Link>
                        </div>
                    </div>
                </div>

                {errorMessage  && <div className="pg-alert pg-alert-error">{errorMessage}</div>}
                {successMessage && <div className="pg-alert pg-alert-success">{successMessage}</div>}

                <div className="pg-card">

                    {/* ── Row 1: Customer / Bill Date / Bill No / Total Qty / Disc Type / Disc % ── */}
                    <div className="pg-hpanel">
                        <div className="pg-hcell" style={{ flex: '3 1 0' }}>
                            <span className="pg-hcell-label">Customer Name <span className="req">*</span></span>
                            <input className="pg-hcell-input" type="text" placeholder="Customer Name"
                                value={formData.CustomerName || ''} onChange={handleChange} name="CustomerName" maxLength={100} />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">Bill Date <span className="req">*</span></span>
                            <input className="pg-hcell-input" type="date"
                                value={formatDateForInput(formData.BillDate)} onChange={handleChange} name="BillDate" readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '0 0 80px' }}>
                            <span className="pg-hcell-label">Bill No</span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="text"
                                value={formData.BillNumber || ''} readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '0 0 80px' }}>
                            <span className="pg-hcell-label">Total Qty</span>
                            <input className="pg-hcell-input pg-hcell-readonly text-right" type="text"
                                value={formData.TotalQuantity || ''} readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">Addt'l Disc Type</span>
                            <select className="pg-hcell-input" value={selectedDiscType}
                                onChange={e => { setSelectedDiscType(e.target.value); setFormData(p => ({ ...p, DiscTypeId: e.target.value })); }}>
                                <option value="">Disc Type</option>
                                {dropdownDiscTypeOptions.map(o => <option key={o.Id} value={o.Id}>{o.Name}</option>)}
                            </select>
                        </div>
                        <div className="pg-hcell" style={{ flex: '0 0 80px' }}>
                            <span className="pg-hcell-label">Addt'l Disc %</span>
                            <input className="pg-hcell-input text-right" type="number" placeholder="0"
                                value={formData.AdditionalDiscountPercentage || ''} onChange={handleChange} name="AdditionalDiscountPercentage" />
                        </div>
                    </div>

                    {/* ── Row 2: Address / GST / Phone / SalesMan / GWP ── */}
                    <div className="pg-hpanel" style={{ marginTop: 8 }}>
                        <div className="pg-hcell" style={{ flex: '3 1 0' }}>
                            <span className="pg-hcell-label">Address</span>
                            <input className="pg-hcell-input" type="text" placeholder="Address"
                                value={formData.CustomerAddress || ''} onChange={handleChange} name="CustomerAddress" maxLength={200} />
                        </div>
                        <div className="pg-hcell" style={{ flex: '2 1 0' }}>
                            <span className="pg-hcell-label">GST Number</span>
                            <input className="pg-hcell-input" type="text" placeholder="GST Number"
                                value={formData.GSTNumber || ''} onChange={handleChange} name="GSTNumber" maxLength={15} />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">Phone No <span className="req">*</span></span>
                            <input className="pg-hcell-input" type="text" placeholder="Phone Number"
                                value={formData.ContactNumber || ''} onChange={handleChange} name="ContactNumber" maxLength={15} />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">Sales Man <span className="req">*</span></span>
                            <select className="pg-hcell-input" value={selectedSalesMan}
                                onChange={e => { setSelectedSalesMan(e.target.value); setFormData(p => ({ ...p, SalesManId: e.target.value })); }}>
                                <option value="">Sales Man</option>
                                {dropdownSalesManOptions.map(o => <option key={o.Id} value={o.Id}>{o.Name}</option>)}
                            </select>
                        </div>
                        <div className="pg-hcell" style={{ flex: '0 0 80px' }}>
                            <span className="pg-hcell-label">GWP/PWP</span>
                            <select className="pg-hcell-input" value={selectedGWPorPWP}
                                onChange={e => { const v = e.target.value === "true"; setSelectedGWPorPWP(v); setFormData(p => ({ ...p, GWPorPWPIncluded: v })); }}>
                                <option value={false}>NO</option>
                                <option value={true}>YES</option>
                            </select>
                        </div>
                    </div>

                    {/* ── Conditional: SC Membership / Voucher Number ── */}
                    {(formData.DiscTypeId == 1 || formData.DiscTypeId == 2) && (
                        <div className="pg-hpanel" style={{ marginTop: 8 }}>
                            {formData.DiscTypeId == 1 && (
                                <div className="pg-hcell" style={{ flex: '2 1 0' }}>
                                    <span className="pg-hcell-label">SC Membership Number <span className="req">*</span></span>
                                    <input className="pg-hcell-input" type="text" placeholder="SC Membership Number"
                                        value={formData.SCMembershipNumber || ''} onChange={handleChange} name="SCMembershipNumber" maxLength={100} />
                                </div>
                            )}
                            {formData.DiscTypeId == 2 && (
                                <div className="pg-hcell" style={{ flex: '2 1 0' }}>
                                    <span className="pg-hcell-label">Voucher Number <span className="req">*</span></span>
                                    <input className="pg-hcell-input" type="text" placeholder="Voucher Number"
                                        value={formData.VoucherNumber || ''} onChange={handleChange} name="VoucherNumber" maxLength={100} />
                                </div>
                            )}
                            <div className="pg-hcell" style={{ flex: '5 1 0' }} />
                        </div>
                    )}

                    {/* ── Add Item Bar ── */}
                    <div className="pg-item-bar" style={{ marginTop: 12 }}>
                        {errorMessageModel && (
                            <div className="pg-alert pg-alert-error" style={{ width: '100%', marginBottom: 0 }}>
                                {errorMessageModel}
                            </div>
                        )}
                        <div className="pg-field" style={{ flex: '3 1 200px' }}>
                            <label className="pg-label">Item Name</label>
                            <div style={{ marginTop: 6 }}>
                                <Select
                                    value={selectedItems}
                                    onChange={handleItemSelect}
                                    options={itemsOptions}
                                    placeholder="Search items..."
                                    isSearchable
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    styles={{
                                        control: (base) => ({ ...base, minHeight: 31, height: 31, fontSize: 12.5, borderColor: 'rgba(200,212,224,0.7)', borderRadius: 6 }),
                                        valueContainer: (base) => ({ ...base, padding: '0 10px' }),
                                        indicatorsContainer: (base) => ({ ...base, height: 31 }),
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    }}
                                />
                            </div>
                        </div>
                        <div className="pg-field narrow">
                            <label className="pg-label">Quantity</label>
                            <input className="pg-input text-right" type="number" name="Quantity"
                                placeholder="1" value={modalData.Quantity} onChange={handleModalInputChange}
                                min={1} max={modalData.balanceStock} />
                            {!isValid && <span style={{ color: '#dc2626', fontSize: 11 }}>Exceeds stock</span>}
                        </div>
                        <div style={{ display: 'flex', alignItems: 'flex-end', gap: 6 }}>
                            <button className="pg-btn pg-btn-success" onClick={saveModalData}>
                                <AddIcon /> Add Item
                            </button>
                        </div>
                    </div>

                    {/* ── Invoice Items Table ── */}
                    <div className="pg-invoice-table-wrap">
                        <table className="pg-invoice-table">
                            <thead>
                                <tr>
                                    <th style={{ width: 36, textAlign: 'center' }}>#</th>
                                    <th>Item Name</th>
                                    <th className="right">Qty</th>
                                    <th className="right">MRP</th>
                                    <th className="right">Disc %</th>
                                    <th className="right">Addt'l Disc %</th>
                                    <th className="right">Total</th>
                                    <th className="right" style={{ width: 50 }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {invoicedeatils.length === 0
                                    ? <tr><td colSpan={8} style={{ textAlign: 'center', color: '#94a3b8', padding: 14 }}>No items added yet.</td></tr>
                                    : invoicedeatils.map((item, index) => (
                                        <tr key={index}>
                                            <td style={{ textAlign: 'center' }}>{index + 1}</td>
                                            <td style={{ width: '30%' }}>{item.ItemName}</td>
                                            <td className="right">{item.Quantity}</td>
                                            <td className="right">{item.Rate}</td>
                                            <td className="right">{item.DiscountPercentage}</td>
                                            <td className="right">{item.AdditionalDiscountPercentage}</td>
                                            <td className="right" style={{ fontWeight: 700 }}>{item.TotalAmount}</td>
                                            <td className="right">
                                                <IconButton size="small" onClick={() => removeRecord(index)} title="Remove">
                                                    <DeleteIcon style={{ fontSize: 16, color: '#dc2626' }} />
                                                </IconButton>
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>

                    {/* ── Totals Panel ── */}
                    <div style={tpanelStyle}>
                        {/* Left: summary key-value rows */}
                        <div style={tleftStyle}>
                            <div style={tsumRowStyle}>
                                <span style={tsumLabelStyle}>Amount</span>
                                <input style={tsumReadonlyStyle} type="text" value={formData.TotalAmount || ''} readOnly />
                            </div>
                            <div style={tsumRowStyle}>
                                <span style={tsumLabelStyle}>Discount</span>
                                <input style={tsumReadonlyStyle} type="text" value={formData.DiscountAmount || ''} readOnly />
                            </div>
                            <div style={tsumRowStyle}>
                                <span style={tsumLabelStyle}>Cash Disc</span>
                                <input style={tsumReadonlyStyle} type="text" value={formData.CashDiscount || '0'} readOnly />
                            </div>
                            <div style={tsumRowStyle}>
                                <span style={tsumLabelStyle}>GV Amount</span>
                                <input style={tsumInputStyle} type="text" placeholder="0.00"
                                    value={formData.GVAmount || ''} onChange={handleChange} name="GVAmount" />
                            </div>
                            <div style={tsumRowStyle}>
                                <span style={tsumLabelStyle}>Net Amount</span>
                                <input style={tsumReadonlyStyle} type="text" value={formData.TaxableAmount || ''} readOnly />
                            </div>
                            <div style={{ marginTop: 8, paddingTop: 8, borderTop: '1px dashed rgba(200,212,224,0.6)', display: 'flex', alignItems: 'center', gap: 8 }}>
                                <input type="checkbox" id="isStockTransfer" checked={formData.IsStockTransfer || false}
                                    name="IsStockTransfer" onChange={handleChange} style={{ transform: 'scale(1.2)', accentColor: 'darkblue' }} />
                                <label htmlFor="isStockTransfer" style={{ fontWeight: 700, color: 'darkblue', cursor: 'pointer', fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.3px', whiteSpace: 'nowrap' }}>
                                    Inter City Stock Transfer
                                </label>
                            </div>
                        </div>

                        {/* Right: Remarks + GST + Grand Total + Payments */}
                        <div style={trightStyle}>
                            {/* Remarks */}
                            <div style={{ marginBottom: 8 }}>
                                <div style={{ fontSize: 10, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.3px', marginBottom: 3 }}>Remarks</div>
                                <input className="pg-hcell-input" type="text" placeholder="Remarks"
                                    value={formData.Remarks || ''} onChange={handleChange} name="Remarks" maxLength={200} />
                            </div>

                            {/* GST row */}
                            <div style={{ display: 'flex', gap: 6, marginBottom: 8 }}>
                                {[
                                    { label: 'CGST',      val: formData.CGSTAmount },
                                    { label: 'SGST',      val: formData.SGSTAmount },
                                    { label: 'IGST',      val: formData.IGSTAmount },
                                    { label: 'Round Off', val: formData.RoundOff   },
                                ].map(({ label, val }) => (
                                    <div key={label} style={{ flex: 1, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', background: '#f1f5f9', border: '1px solid rgba(200,212,224,0.5)', borderRadius: 5, padding: '4px 10px', gap: 8 }}>
                                        <span style={{ fontSize: 9.5, fontWeight: 600, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.4px', whiteSpace: 'nowrap' }}>{label}</span>
                                        <span style={{ fontSize: 12, fontWeight: 700, color: '#334155', fontVariantNumeric: 'tabular-nums' }}>{val || '0.00'}</span>
                                    </div>
                                ))}
                            </div>

                            {/* Grand Total bar */}
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: 'linear-gradient(135deg,#1c2a3a 0%,#2d3f52 100%)', borderRadius: 6, padding: '7px 14px', marginBottom: 8 }}>
                                <span style={{ fontSize: 11, fontWeight: 700, color: '#c9a96e', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Grand Total</span>
                                <span style={{ fontSize: 16, fontWeight: 700, color: '#fff', fontVariantNumeric: 'tabular-nums' }}>{formData.GrandTotal || '0.00'}</span>
                            </div>

                            {/* Payment row */}
                            <div style={{ display: 'flex', gap: 8 }}>
                                {/* Cash */}
                                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 3 }}>
                                    <span style={{ fontSize: 10, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.3px' }}>Cash <span style={{ color: '#c0392b' }}>*</span></span>
                                    <input style={{ width: '100%', height: 28, padding: '0 8px', border: '1.5px solid rgba(200,212,224,0.8)', borderRadius: 5, fontSize: 12.5, fontWeight: 700, textAlign: 'right', background: '#f5f7fa', color: formData.CashAmount < 0 ? '#c0392b' : '#475569', boxSizing: 'border-box', fontFamily: 'inherit' }}
                                        type="text" value={formData.CashAmount || ''} readOnly />
                                </div>
                                {/* Card */}
                                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 3 }}>
                                    <span style={{ fontSize: 10, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.3px' }}>Card <span style={{ color: '#c0392b' }}>*</span></span>
                                    <input style={{ width: '100%', height: 28, padding: '0 8px', border: '1.5px solid rgba(200,212,224,0.8)', borderRadius: 5, fontSize: 12.5, fontWeight: 700, textAlign: 'right', background: '#fff', color: '#1e293b', boxSizing: 'border-box', fontFamily: 'inherit' }}
                                        type="text" placeholder="0.00" value={formData.CardAmount || ''} onChange={handleChange} name="CardAmount" />
                                </div>
                                {/* UPI */}
                                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 3 }}>
                                    <span style={{ fontSize: 10, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.3px' }}>UPI / RTGS / Other <span style={{ color: '#c0392b' }}>*</span></span>
                                    <input style={{ width: '100%', height: 28, padding: '0 8px', border: '1.5px solid rgba(200,212,224,0.8)', borderRadius: 5, fontSize: 12.5, fontWeight: 700, textAlign: 'right', background: '#fff', color: '#1e293b', boxSizing: 'border-box', fontFamily: 'inherit' }}
                                        type="text" placeholder="0.00" value={formData.UPIAmount || ''} onChange={handleChange} name="UPIAmount" />
                                </div>
                            </div>

                            {/* Card / UPI extra details */}
                            {(formData.CardAmount > 0 || formData.UPIAmount > 0) && (
                                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 6, paddingTop: 6, borderTop: '1px dashed rgba(200,212,224,0.6)' }}>
                                    {formData.CardAmount > 0 && (
                                        <>
                                            <div style={{ flex: '1 1 120px', display: 'flex', flexDirection: 'column', gap: 3 }}>
                                                <span style={{ fontSize: 10, fontWeight: 600, color: '#64748b', textTransform: 'uppercase' }}>Card Type <span style={{ color: '#c0392b' }}>*</span></span>
                                                <select style={{ width: '100%', height: 28, padding: '0 8px', border: '1.5px solid rgba(200,212,224,0.8)', borderRadius: 5, fontSize: 12.5, fontWeight: 600, color: '#1e293b', background: '#fff', boxSizing: 'border-box', fontFamily: 'inherit' }}
                                                    value={selectedCardType}
                                                    onChange={e => { setSelectedCardType(e.target.value); setFormData(p => ({ ...p, CardType: e.target.value })); }}>
                                                    <option value="">Select</option>
                                                    {dropdownCardTypeOptions.map(o => <option key={o.Id} value={o.Id}>{o.Name}</option>)}
                                                </select>
                                            </div>
                                            <div style={{ flex: '1 1 120px', display: 'flex', flexDirection: 'column', gap: 3 }}>
                                                <span style={{ fontSize: 10, fontWeight: 600, color: '#64748b', textTransform: 'uppercase' }}>Card Number <span style={{ color: '#c0392b' }}>*</span></span>
                                                <input style={{ width: '100%', height: 28, padding: '0 8px', border: '1.5px solid rgba(200,212,224,0.8)', borderRadius: 5, fontSize: 12.5, fontWeight: 600, color: '#1e293b', background: '#fff', boxSizing: 'border-box', fontFamily: 'inherit' }}
                                                    type="text" placeholder="Card Number" value={formData.CardNumber || ''} onChange={handleChange} name="CardNumber" maxLength={20} />
                                            </div>
                                        </>
                                    )}
                                    {formData.UPIAmount > 0 && (
                                        <div style={{ flex: '2 1 160px', display: 'flex', flexDirection: 'column', gap: 3 }}>
                                            <span style={{ fontSize: 10, fontWeight: 600, color: '#64748b', textTransform: 'uppercase' }}>UPI/RTGS/Other Number <span style={{ color: '#c0392b' }}>*</span></span>
                                            <input style={{ width: '100%', height: 28, padding: '0 8px', border: '1.5px solid rgba(200,212,224,0.8)', borderRadius: 5, fontSize: 12.5, fontWeight: 600, color: '#1e293b', background: '#fff', boxSizing: 'border-box', fontFamily: 'inherit' }}
                                                type="text" placeholder="UPI/RTGS Number" value={formData.UPINumber || ''} onChange={handleChange} name="UPINumber" maxLength={20} />
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>

                </div>{/* end pg-card */}

                <div className="pg-watermark"><CopyrightIcon style={{ fontSize: 12 }} /><b>EFFTABS SOLUTIONS LLP</b></div>

                {/* ── Confirm Remove Modal ── */}
                {confirmRemove !== null && (
                    <div className="pg-modal-backdrop" onClick={() => setConfirmRemove(null)}>
                        <div className="pg-modal-card" onClick={e => e.stopPropagation()}>
                            <div className="pg-modal-icon-wrap"><WarningAmberIcon className="pg-modal-icon" /></div>
                            <h6 className="pg-modal-title">Remove Item?</h6>
                            <p className="pg-modal-body">This item will be removed from the invoice. This action cannot be undone.</p>
                            <div className="pg-modal-actions">
                                <button className="pg-modal-btn pg-modal-btn-cancel" onClick={() => setConfirmRemove(null)}>Cancel</button>
                                <button className="pg-modal-btn pg-modal-btn-confirm" onClick={confirmRemoveRecord}>
                                    <DeleteIcon style={{ fontSize: 15 }} /> Yes, Remove
                                </button>
                            </div>
                        </div>
                    </div>
                )}

            </div>
        </Fragment>
    );
};

export default SaleCreate;
